/**
 * Controles de detalle de un reporte expandible.
 *
 * El selector tiene TRES modos, no cuatro. «Cuentas + apuntes» no es un modo
 * del estado financiero: los apuntes no viajan con el árbol, se piden por
 * cuenta. Ofrecerlo aquí contradiría esa decisión y arrastraría miles de filas
 * que casi nadie mira. Existe solo como nivel de exportación.
 *
 * Por lo mismo el botón dice «Expandir a cuentas» y no «Expandir todo»: lo
 * segundo sugeriría que también se cargan los movimientos.
 */

import type { TreeMode } from "../api/types";

const MODOS: { value: TreeMode; label: string }[] = [
  { value: "formal", label: "Formato oficial" },
  { value: "groups", label: "Grupos" },
  { value: "accounts", label: "Cuentas" },
];

interface Props {
  mode: TreeMode;
  onMode: (mode: TreeMode) => void;
  fullChain: boolean;
  onFullChain: (value: boolean) => void;
  showZero: boolean;
  onShowZero: (value: boolean) => void;
  onExpand: () => void;
  onCollapse: () => void;
  /** Modos que este reporte admite; los demás se deshabilitan. */
  allowed?: TreeMode[];
  offerFullChain?: boolean;
}

export function DetailToolbar({
  mode,
  onMode,
  fullChain,
  onFullChain,
  showZero,
  onShowZero,
  onExpand,
  onCollapse,
  allowed,
  offerFullChain = true,
}: Props) {
  const admitido = (value: TreeMode) => !allowed || allowed.includes(value);

  return (
    <div className="toolbar toolbar-detail">
      <div className="field">
        <label htmlFor="detalle">Detalle</label>
        <select
          id="detalle"
          value={mode}
          onChange={(event) => onMode(event.target.value as TreeMode)}
        >
          {MODOS.filter((m) => admitido(m.value)).map((m) => (
            <option key={m.value} value={m.value}>
              {m.label}
            </option>
          ))}
        </select>
      </div>

      <button type="button" className="btn" onClick={onCollapse}>
        Contraer todo
      </button>
      <button
        type="button"
        className="btn"
        onClick={onExpand}
        disabled={mode === "formal"}
      >
        Expandir a cuentas
      </button>

      {offerFullChain && (
        <label className="check">
          <input
            type="checkbox"
            checked={fullChain}
            onChange={(event) => onFullChain(event.target.checked)}
            disabled={mode === "formal"}
          />
          Cadena Odoo completa
        </label>
      )}
      <label className="check">
        <input
          type="checkbox"
          checked={showZero}
          onChange={(event) => onShowZero(event.target.checked)}
        />
        Mostrar cuentas en cero
      </label>

      <div className="spacer" />
    </div>
  );
}
